module.exports = function() {
    return {
        run() {
            // Закрыть все модальные окна
            function closeAllModals() {
                $('#modal-info').fadeOut(300);
                $('#modal-inf-letter').fadeOut(300);
                $('#modal-expert-consultation').fadeOut(300);
                $('#modal-make-examination').fadeOut(300);
                $('#modal-ask-question').fadeOut(300);
                // Модальное окно в модальном
                if ($('#modal-ask-question').is(':hidden') &&
                    $('#modal-inf-letter').is(':hidden') &&
                    $('#modal-expert-consultation').is(':hidden') &&
                    $('#modal-make-examination').is(':hidden')) {
                        $('.city-selection-modal').hide(300);
                }
            }

            $('body').on('click', '.city-selection-modal-content .close', function() {
                closeAllModals();
            });
            $('body').on('click', '.city-selection-modal-content .close-button', function() {
                closeAllModals();
            });
            // Клик вне модального окна чтобы закрыть его
            $(document).mouseup(function(event) {
                let modal = $(".city-selection-modal-content");
                if (!modal.is(event.target)
                    && modal.has(event.target).length === 0) {
                        closeAllModals();
                }
            });
        }
    }
}
